(() => {
  const lifecycleKey = Symbol.for('artbox.home.lifecycle');
  if (window[lifecycleKey]) {
    window[lifecycleKey].initialise(document);
    return;
  }

  const records = new WeakMap();

  function updateControls(root) {
    const rail = root.querySelector('[data-artbox-home-recommendations-rail]');
    const previous = root.querySelector('[data-artbox-home-rail-prev]');
    const next = root.querySelector('[data-artbox-home-rail-next]');
    if (!rail || !previous || !next) return;
    const maximum = Math.max(0, rail.scrollWidth - rail.clientWidth);
    const start = Number.parseFloat(getComputedStyle(rail).paddingLeft) || 0;
    previous.disabled = rail.scrollLeft <= start + 2;
    next.disabled = rail.scrollLeft >= maximum - 2;
  }

  function moveRail(root, direction) {
    const rail = root.querySelector('[data-artbox-home-recommendations-rail]');
    const firstCard = rail?.firstElementChild;
    if (!rail || !firstCard) return;
    const gap = Number.parseFloat(getComputedStyle(rail).columnGap || getComputedStyle(rail).gap) || 0;
    rail.scrollBy({
      left: direction * (firstCard.getBoundingClientRect().width + gap),
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',
    });
  }

  function initialiseRoot(root) {
    if (records.has(root)) return;
    const rail = root.querySelector('[data-artbox-home-recommendations-rail]');
    if (!rail) return;
    const handleClick = (event) => {
      if (event.target.closest('[data-artbox-home-rail-prev]')) moveRail(root, -1);
      if (event.target.closest('[data-artbox-home-rail-next]')) moveRail(root, 1);
    };
    const handleScroll = () => updateControls(root);
    const observer = 'ResizeObserver' in window ? new ResizeObserver(handleScroll) : null;
    observer?.observe(rail);
    rail.querySelectorAll('.artbox-collection-card').forEach((card) => observer?.observe(card));
    root.addEventListener('click', handleClick);
    rail.addEventListener('scroll', handleScroll, { passive: true });
    window.addEventListener('resize', handleScroll);
    records.set(root, { rail, handleClick, handleScroll, observer });
    root.dataset.artboxHomeReady = 'true';
    requestAnimationFrame(handleScroll);
  }

  function initialise(scope) {
    if (scope.matches?.('[data-artbox-home]')) initialiseRoot(scope);
    scope.querySelectorAll?.('[data-artbox-home]').forEach(initialiseRoot);
  }

  function unload(event) {
    const root = event.target.matches?.('[data-artbox-home]')
      ? event.target
      : event.target.querySelector?.('[data-artbox-home]');
    const record = root && records.get(root);
    if (!record) return;
    record.observer?.disconnect();
    root.removeEventListener('click', record.handleClick);
    record.rail.removeEventListener('scroll', record.handleScroll);
    window.removeEventListener('resize', record.handleScroll);
    records.delete(root);
  }

  window[lifecycleKey] = { initialise, unload };
  document.addEventListener('shopify:section:load', (event) => initialise(event.target));
  document.addEventListener('shopify:section:unload', unload);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialise(document), { once: true });
  } else {
    initialise(document);
  }
})();
